export default __webpack_public_path__ + "static/badge-enter-sale-f012034d07daa4e5a740942395f97f1d.webp";